import React from "react";

function FalseIcon(props) {
  return (
    <div>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        version="1.1"
        width={props.width || 18}
        height={props.height || 18}
        viewBox="0 0 256 256"
        fill={props.color || "#d04949"}
      >
        <defs></defs>
        <g transform="translate(1.4065934065934016 1.4065934065934016) scale(2.81 2.81)">
          <path
            d="M 45 0 C 20.187 0 0 20.187 0 45 c 0 24.813 20.187 45 45 45 c 24.813 0 45 -20.187 45 -45 C 90 20.187 69.813 0 45 0 z M 66.897 61.241 c 1.563 1.562 1.563 4.095 0 5.656 c -0.78 0.781 -1.805 1.172 -2.828 1.172 s -2.048 -0.391 -2.828 -1.172 L 45 50.656 L 28.759 66.897 c -0.781 0.781 -1.805 1.172 -2.829 1.172 c -1.024 0 -2.047 -0.391 -2.829 -1.172 c -1.562 -1.562 -1.562 -4.095 0 -5.656 L 39.343 45 L 23.102 28.759 c -1.562 -1.563 -1.562 -4.095 0 -5.657 c 1.563 -1.562 4.095 -1.562 5.657 0 L 45 39.343 l 16.241 -16.241 c 1.561 -1.562 4.094 -1.562 5.656 0 c 1.563 1.562 1.563 4.095 0 5.657 L 50.656 45 L 66.897 61.241 z"
            transform=" matrix(1 0 0 1 0 0) "
            stroke-linecap="round"
          />
        </g>
      </svg>
    </div>
  );
}

export default FalseIcon;
